import { useState } from 'react';
import IconAdd from '../../../components/icons/IconAdd';
import IconDelete from '../../../components/icons/IconDelete';
import RichTextEditor from '../../../components/RichTextEditor';
import { renderRichText } from '../../../utils/richText';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { question: '', options: [{ id: 1, text: '' }, { id: 2, text: '' }], correctIds: [], multiple: false };

// Module-level counter for option ids added during editing (not real DB
// ids - just needs to stay unique within a block's own option list, and a
// monotonically-increasing counter starting above the default {id:1,id:2}
// guarantees that cheaply, no uuid dependency needed).
let nextOptionId = 1000;

export default function MultipleChoiceEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [question, setQuestion] = useState(initial.question || '');
   const [options, setOptions] = useState(initial.options && initial.options.length ? initial.options : DEFAULT.options);
   const [correctIds, setCorrectIds] = useState(initial.correctIds || []);
   const [multiple, setMultiple] = useState(!!initial.multiple);

   const updateOption = (id, text) => setOptions(prev => prev.map(o => o.id === id ? { ...o, text } : o));
   const addOption = () => setOptions(prev => [...prev, { id: nextOptionId++, text: '' }]);
   const removeOption = (id) => {
      setOptions(prev => prev.filter(o => o.id !== id));
      setCorrectIds(prev => prev.filter(cid => cid !== id));
   };
   const toggleCorrect = (id) => {
      setCorrectIds(prev => {
         if(multiple) return prev.includes(id) ? prev.filter(cid => cid !== id) : [...prev, id];
         return [id];
      });
   };
   const handleMultipleToggle = (checked) => {
      setMultiple(checked);
      setCorrectIds([]);
   };

   const handleSave = () => {
      const cleanOptions = options.filter(o => o.text.trim());
      const cleanCorrectIds = correctIds.filter(id => cleanOptions.some(o => o.id === id));
      onSave({ text: question, config: JSON.stringify({ question, options: cleanOptions, correctIds: cleanCorrectIds, multiple }) });
   };

   return (
      <div className='exercise-block-mc-editor'>
         <RichTextEditor rows={1} value={question} placeholder='Питання' onChange={setQuestion} />
         <label className='exercise-block-checkbox-row'>
            <input type='checkbox' checked={multiple} onChange={e => handleMultipleToggle(e.target.checked)} /> Декілька правильних відповідей
         </label>
         {options.map(opt => (
            <div className='exercise-block-mc-option-row' key={opt.id}>
               <input type={multiple ? 'checkbox' : 'radio'} checked={correctIds.includes(opt.id)} onChange={() => toggleCorrect(opt.id)} />
               <RichTextEditor rows={1} value={opt.text} placeholder='Варіант відповіді' onChange={value => updateOption(opt.id, value)} />
               <div className='exercise-block-item-remove-btn' onClick={() => removeOption(opt.id)}><IconDelete style={{fill:'#e0876c', width:14, height:14, margin:0}} /></div>
            </div>
         ))}
         <div className='exercise-block-item-add-btn' onClick={addOption}><IconAdd /> Додати варіант</div>
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderMultipleChoicePreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   const options = (cfg.options || []).filter(o => o.text && o.text.trim());
   if(!cfg.question && options.length === 0) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   return (
      <div className='exercise-block-mc-preview'>
         {cfg.question ? <p className='exercise-block-prompt-text'>{renderRichText(cfg.question)}</p> : ''}
         <ul className='exercise-block-mc-options-preview'>
            {options.map(o => (
               <li key={o.id} className={cfg.correctIds && cfg.correctIds.includes(o.id) ? 'correct' : ''}>{renderRichText(o.text)}</li>
            ))}
         </ul>
      </div>
   );
}
